import { getDefinition } from "./catalog";
import { effectiveTerminals } from "./effective";
import { terminalAbsPosition } from "./terminal-snap";
import type { ComponentNode, System } from "./types";

export type ExamplePoint = { x: number; y: number };
type Route = (from: ExamplePoint, to: ExamplePoint) => ExamplePoint[];

/** Authored examples keep their cable corridors when opened in the editor.
 * Waypoints are drawing coordinates, never physical cable lengths. */
export function routeExample(system: System, routes: Record<string, Route>): System {
  const endpoint = (nodeId: string, terminalId: string) => {
    const node = system.nodes.find((item): item is ComponentNode => item.id === nodeId && item.kind === "component")!;
    const definition = getDefinition(node.definitionId, node.customDefinition)!;
    const terminal = effectiveTerminals(definition, node).find((item) => item.id === terminalId)!;
    return terminalAbsPosition(node, definition, terminal, system.nodes);
  };
  return { ...system, cables: system.cables.map((cable) => ({
    ...cable,
    waypoints: routes[cable.id](endpoint(cable.fromNodeId, cable.fromTerminalId), endpoint(cable.toNodeId, cable.toTerminalId)),
  })) };
}

/** Two clean elbows through a chosen vertical corridor. */
export const viaX = (x: number): Route => (from, to) => [{ x, y: from.y }, { x, y: to.y }];
